import { randomItem } from '../lib/utils';
import { FIGURINES_WITH_STARS } from '../app/const/features';
import { appStorage } from '../app/storage';
var slices = [
    // Диагонали
    {
        gridSize: 2,
        data: [0, 1, 1, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 1, 0, 1, 0, 1, 0, 0],
    },
    {
        gridSize: 2,
        data: [1, 0, 0, 1],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    },
    // Кубик
    {
        gridSize: 2,
        data: [1, 1, 1, 1],
    },
    // Одна клетка
    {
        gridSize: 3,
        data: [0, 0, 0, 0, 1, 0, 0, 0, 0],
    },
    // Крестик
    {
        gridSize: 3,
        data: [0, 1, 0, 1, 1, 1, 0, 1, 0],
    },
    // T-образные
    {
        gridSize: 3,
        data: [0, 1, 0, 0, 1, 0, 1, 1, 1],
    },
    {
        gridSize: 3,
        data: [1, 1, 1, 0, 1, 0, 0, 1, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 1, 1, 1, 1, 0, 0, 1],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 1, 1, 1, 1, 0, 0],
    },
    // Малые T-образные
    {
        gridSize: 3,
        data: [0, 0, 0, 0, 1, 0, 1, 1, 1],
    },
    {
        gridSize: 3,
        data: [1, 1, 1, 0, 1, 0, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 1, 0, 1, 1, 0, 0, 1],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 1, 1, 0, 1, 0, 0],
    },
    // Г-образные
    {
        gridSize: 3,
        data: [1, 1, 0, 1, 0, 0, 1, 0, 0],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 1, 0, 0, 1, 1, 0],
    },
    {
        gridSize: 3,
        data: [0, 1, 1, 0, 0, 1, 0, 0, 1],
    },
    {
        gridSize: 3,
        data: [0, 0, 1, 0, 0, 1, 0, 1, 1],
    },
    // Уголки
    {
        gridSize: 3,
        data: [1, 1, 0, 1, 0, 0, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 0, 1, 0, 0, 1, 1, 0],
    },
    {
        gridSize: 3,
        data: [0, 1, 1, 0, 0, 1, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 0, 0, 0, 1, 0, 1, 1],
    },
    // Большие уголки
    {
        gridSize: 3,
        data: [1, 1, 1, 1, 0, 0, 1, 0, 0],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 1, 0, 0, 1, 1, 1],
    },
    {
        gridSize: 3,
        data: [1, 1, 1, 0, 0, 1, 0, 0, 1],
    },
    {
        gridSize: 3,
        data: [0, 0, 1, 0, 0, 1, 1, 1, 1],
    },
    // Палки
    {
        gridSize: 3,
        data: [0, 0, 0, 1, 1, 1, 0, 0, 0],
    },
    {
        gridSize: 4,
        data: [0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 1, 0, 0, 1, 0, 0, 1, 0],
    },
    {
        gridSize: 4,
        data: [0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0],
    },
    // Зигзаги
    {
        gridSize: 3,
        data: [0, 1, 1, 1, 1, 0],
    },
    {
        gridSize: 3,
        data: [1, 1, 0, 0, 1, 1],
    },
    {
        gridSize: 3,
        data: [1, 0, 0, 1, 1, 0, 0, 1, 0],
    },
    {
        gridSize: 3,
        data: [0, 1, 0, 1, 1, 0, 1, 0, 0],
    },
    // C-type
    {
        gridSize: 3,
        data: [1, 1, 0, 1, 0, 0, 1, 1, 0],
    },
    {
        gridSize: 3,
        data: [1, 1, 1, 1, 0, 1, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 1, 1, 0, 0, 1, 0, 1, 1],
    },
    {
        gridSize: 3,
        data: [0, 0, 0, 1, 0, 1, 1, 1, 1],
    },
    // Палки 2x
    {
        gridSize: 3,
        data: [0, 0, 0, 0, 1, 1, 0, 0, 0],
    },
    {
        gridSize: 3,
        data: [0, 0, 0, 0, 1, 0, 0, 1, 0],
    },
];
export function makeSlice(index) {
    var _a = typeof index !== 'undefined' ? slices[index] : randomItem(slices), gridSize = _a.gridSize, data = _a.data;
    var value = FIGURINES_WITH_STARS && appStorage.get().learned && Math.random() > 0.75 ? 2 : 1;
    return {
        gridSize: gridSize,
        data: data.map(function (v) { return ({ value: v ? value : 0 }); }),
        pos: { x: 0, y: 0 },
        selected: false,
        move: { x: 0, y: 0 },
        hidden: false,
        cellSize: 20,
    };
}
export function randomSlices() {
    return [makeSlice(), makeSlice(), makeSlice()];
}
export function getSlices(a, b, c) {
    return [makeSlice(a), makeSlice(b), makeSlice(c)];
}
